var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingBlock'):_vm._e(),_c('store-view-item',{attrs:{"status":"store-view-pay"}}),_c('navigation-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }